module.exports = __webpack_public_path__ + "img/desktop-VTA-valoracion-agendada.567e6a41.png";